import ClearIcon from '@mui/icons-material/Clear';
import Modal from '@mui/material/Modal';
import { styled } from '@mui/material/styles';
import React from 'react';
import Colors from '../../colors';

function ModalContainer({ style, children, isVisible, setIsVisible, title, showCloseIcon = true, onClose }) {
    const containerStyles = {
        position: 'absolute',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%, -50%)',
        width: '350px',
        maxHeight: '95%',
        overflowY: 'auto',
        maxWidth: '90%',
        backgroundColor: 'white',
        border: `0.5px solid ${Colors.darkGray}`,
        boxShadow: '0px 4px 4px rgba(0, 0, 0, 0.25)',
        borderRadius: '20px',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        gap: '20px',
        padding: '10px 10px 25px 10px',
        ...style,
    };

    const clearIconStyles = {
        position: 'absolute',
        top: '15px',
        right: '15px',
        fontSize: '23px',
        '&:hover': {
            cursor: 'pointer',
            opacity: 0.7,
        }
    };

    const ModalTitle = styled('h3')({
        textAlign: 'center',
        marginTop: '30px',
        marginBottom: '15px',
        maxWidth: '80%',
    });

    const handleClose = () => {
        onClose && onClose()
        setIsVisible(false)
    }

    return (
        <Modal
            open={isVisible}
            onClose={handleClose}
            aria-labelledby="modal-modal-title"
        >
            <div style={containerStyles}>
                {showCloseIcon && <ClearIcon onClick={handleClose} sx={clearIconStyles} />}
                {title && <ModalTitle>{title}</ModalTitle>}
                {children}
            </div>
        </Modal>

    )
}

export default ModalContainer